module.exports = __webpack_public_path__ + "img/sch5-intro-web.0b093f1a.png";